import { useTranslation } from 'react-i18next';
import { ImageIcon } from 'lucide-react';
import { Button } from '@/components/v2/ui';
import { EID } from '@/lib/element-ids.registry';

interface ProductHeroImageProps {
  imageUrl: string | null | undefined;
  imageCount: number;
  onManageImages: () => void;
}

export function ProductHeroImage({ imageUrl, imageCount, onManageImages }: ProductHeroImageProps) {
  const { t } = useTranslation();

  return (
    <div className="product-hero-image relative group flex-shrink-0">
      <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-xl bg-neutral-50 dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 flex items-center justify-center overflow-hidden">
        {imageUrl ? (
          <img src={imageUrl} alt="" className="w-full h-full object-cover" />
        ) : (
          <ImageIcon className="w-8 h-8 text-neutral-400 dark:text-neutral-500" aria-label={t('products.hero.noImage')} />
        )}
      </div>

      <div className="absolute inset-0 rounded-xl flex items-center justify-center transition-colors group-hover:bg-black/10 dark:group-hover:bg-white/10">
        <Button
          id={EID['product-hero-manage-images-btn']}
          variant="secondary"
          size="sm"
          className="opacity-0 group-hover:opacity-100 transition-opacity text-xs px-2 py-1"
          onClick={onManageImages}
        >
          {t('products.hero.manageImages')}
        </Button>
      </div>

      {imageCount > 0 && (
        <div className="absolute bottom-1 left-1 bg-neutral-900/80 dark:bg-neutral-200/90 text-white dark:text-neutral-900 text-2xs font-medium px-1.5 py-0.5 rounded-md">
          {t('products.hero.imageCount', { count: imageCount })}
        </div>
      )}
    </div>
  );
}
